<p-toast position="top-right" />

<!-- ===== Main Serial Numbers Dialog ===== -->
<p-dialog
  [visible]="visible"
  (visibleChange)="close()"
  header="Serial Numbers"
  [modal]="true"
  [closable]="true"
  [maximizable]="true"
  [draggable]="false"
  styleClass="kansei-dialog mes-sn-dialog"
  [style]="{ width: '780px', height: '75vh' }"
  [contentStyle]="{ padding: '0', overflow: 'auto' }">

  <!-- Loading State -->
  @if (loading) {
    <div class="mes-loading">
      <i class="ri-loader-4-line mes-loading-icon"></i>
      <span>Loading data...</span>
    </div>
  }

  <!-- No Data State -->
  @if (!loading && groupedBySerial.length === 0) {
    <div class="mes-empty">
      <i class="ri-inbox-line"></i>
      <span>No serial number data found for this MV Power Station.</span>
    </div>
  }

  <!-- Tabs — one per serial number -->
  @if (!loading && groupedBySerial.length > 0) {
    <p-tabs [value]="0">
      <p-tablist>
        @for (item of groupedBySerial; track item.serialNumber; let i = $index) {
          <p-tab [value]="i">{{ item.serialNumber }}</p-tab>
        }
      </p-tablist>

      @for (item of groupedBySerial; track item.serialNumber; let i = $index) {
        <p-tabpanel [value]="i">
          <div class="mes-tab-content">

            <!-- Template Groups -->
            @for (tGroup of item.templateGroups; track tGroup.templateName) {
              <div class="mes-template-group">

                <!-- Template Header -->
                <div class="mes-template-header" (click)="toggleTemplate(tGroup)">
                  <span class="mes-template-name">{{ tGroup.templateName }}</span>
                  <button class="mes-collapse-btn" type="button">
                    <i [class]="tGroup.collapsed ? 'ri-add-line' : 'ri-subtract-line'"></i>
                  </button>
                </div>

                <!-- Sections -->
                @if (!tGroup.collapsed) {
                  @for (section of tGroup.sections; track section.sectionName) {

                    <!-- Section Sub-header -->
                    <div class="mes-section-header">{{ section.sectionName }}</div>

                    <!-- Attribute Rows -->
                    @for (record of section.records; track record.id) {
                      <div class="mes-row" [class.mes-row--editing]="editingId === record.id">
                        <div class="mes-attr-name">{{ record.attributeName }}</div>

                        <!-- Value: view or edit mode -->
                        <div class="mes-attr-value">
                          @if (editingId === record.id) {
                            <input
                              class="mes-edit-input"
                              type="text"
                              [(ngModel)]="editValue"
                              [disabled]="saving"
                              (keyup.enter)="saveEdit(record)"
                              (keyup.escape)="cancelEdit()" />
                          } @else {
                            <span class="mes-value-text">{{ record.attributeValue ?? '—' }}</span>
                          }
                        </div>

                        <!-- Actions -->
                        <div class="mes-actions">
                          <!-- History icon — always visible -->
                          <button
                            class="mes-icon-btn mes-icon-btn--history"
                            [class.mes-icon-btn--history-active]="record.hasHistory"
                            type="button"
                            pTooltip="View History"
                            tooltipPosition="top"
                            (click)="openHistory(record)">
                            <i class="ri-history-line"></i>
                          </button>

                          <!-- Edit / Save button -->
                          @if (editingId === record.id) {
                            <button
                              class="mes-icon-btn mes-icon-btn--save"
                              type="button"
                              pTooltip="Save"
                              tooltipPosition="top"
                              [disabled]="saving"
                              (click)="saveEdit(record)">
                              <i [class]="saving ? 'ri-loader-4-line' : 'ri-save-line'"></i>
                            </button>
                            <button
                              class="mes-icon-btn mes-icon-btn--cancel"
                              type="button"
                              pTooltip="Cancel"
                              tooltipPosition="top"
                              [disabled]="saving"
                              (click)="cancelEdit()">
                              <i class="ri-close-line"></i>
                            </button>
                          } @else {
                            <button
                              class="mes-icon-btn mes-icon-btn--edit"
                              type="button"
                              pTooltip="Edit"
                              tooltipPosition="top"
                              (click)="startEdit(record)">
                              <i class="ri-pencil-line"></i>
                            </button>
                          }
                        </div>
                      </div>
                    }
                  }
                }
              </div>
            }
          </div>
        </p-tabpanel>
      }
    </p-tabs>
  }
</p-dialog>

<!-- ===== History Sub-dialog ===== -->
<p-dialog
  [(visible)]="showHistoryDialog"
  [header]="'History — ' + historyAttributeName"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  styleClass="kansei-dialog"
  [style]="{ width: '520px' }"
  [contentStyle]="{ padding: '0', overflow: 'auto', maxHeight: '50vh' }">

  @if (historyLoading) {
    <div class="mes-loading">
      <i class="ri-loader-4-line mes-loading-icon"></i>
      <span>Loading history...</span>
    </div>
  }

  @if (!historyLoading && historyRecords.length === 0) {
    <div class="mes-empty">
      <i class="ri-inbox-line"></i>
      <span>No history available.</span>
    </div>
  }

  @if (!historyLoading && historyRecords.length > 0) {
    <div class="mes-history-list">
      <div class="mes-history-header-row">
        <span>Old Value</span>
        <span>New Value</span>
        <span>Changed By</span>
        <span>Changed At</span>
      </div>
      @for (h of historyRecords; track h.historyId) {
        <div class="mes-history-row">
          <span class="mes-history-old">{{ h.oldValue ?? '—' }}</span>
          <span class="mes-history-new">{{ h.newValue ?? '—' }}</span>
          <span class="mes-history-user">{{ h.changedByName || 'System' }}</span>
          <span class="mes-history-date">{{ h.changedAt | date:'MM/dd/yyyy HH:mm' }}</span>
        </div>
      }
    </div>
  }
</p-dialog>
